import { handleActions, combineActions } from 'redux-actions'

import * as actions from '../actions'

const defaultState = false

export default handleActions(
  {
    [combineActions(
      actions.getIterations.request,
      actions.getFiltersByIterationId.request,
      actions.getPagesByIterationId.request,

      actions.getContentsForProject.request,
      actions.getPagesForProjectTraining.request
    )]() {
      return true
    },
    [combineActions(
      actions.getIterations.success,
      actions.getIterations.failed,
      actions.getFiltersByIterationId.success,
      actions.getFiltersByIterationId.failed,
      actions.getPagesByIterationId.success,
      actions.getPagesByIterationId.failed,

      actions.getContentsForProject.success,
      actions.getContentsForProject.failed,
      actions.getPagesForProjectTraining.success,
      actions.getPagesForProjectTraining.failed
    )]() {
      return false
    },
  },
  defaultState
)
